﻿import React, { useState } from 'react';
import { CrudFunctions } from '../utilities/crud-functions';
import { ProductBatchListItem } from '../models/product-batch-list-item';

import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';
import GlobalDialog from './Modal/GlobalDialog';

import DataGrid, {
    Column,
    Selection,
    Toolbar,
    Paging,
    Item as ToolBarItem
} from 'devextreme-react/data-grid';

import { TextBox } from 'devextreme-react/text-box';
import { Button } from 'devextreme-react/button';

export interface Props {
    onSubmit?: (batch: ProductBatchListItem) => void;
    onCancel?: () => void;
}

export default function BatchSearch(props: Props) {

    const [batchFilterString, setBatchFilterString] =
        useState<string>();

    const [batches, setBatches] =
        useState<ProductBatchListItem[]>();

    const [selectedBatch, setSelectedBatch] =
        useState<ProductBatchListItem>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    return (
        <div className="pw-form-container">
            <div id="batchesList" className="pw-form-unit">
                <DataGrid
                    height="32rem"
                    onSelectionChanged={searchResultsSelectionChanged}
                    dataSource={batches != null ? batches : []}
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    showBorders={true}>

                    <Selection mode='single' />
                    <Paging enabled={false} />
                    <Column dataField='batchName' width='25%' />
                    <Column dataField='catalogNumber' width='25%' caption='Catalog#' />
                    <Column dataField='batchVersionString' width='25%' caption='Version' />
                    <Column dataField='batchTypeString' width='25%' caption='Type' />
                    
                    <Toolbar>
                        <ToolBarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Batches</div>
                            </div>
                        </ToolBarItem>

                        <ToolBarItem location='after'>
                            <TextBox className="pw-datagrid-toobar-textbox"
                                placeholder="search"
                                hint="search by batch name or product catalog number"
                                value={batchFilterString}
                                onValueChanged={batchFilterChanged} />               
                        </ToolBarItem>

                        <ToolBarItem location='after'>
                            <Button type='success' width={'2em'} icon='find'
                                hint='Search for matching Products or Batches'
                                onClick={onSearchButtonClicked} />
                        </ToolBarItem>
                    </Toolbar>

                </DataGrid>
            </div>

            <div className="pw-comp-row">
                <div className="pw-centered-buttons-container">
                    <Button id="submitButton" text="Submit" icon="save" type="success"
                        className="pw-button"
                        hint="select batch"
                        height='1.8rem'
                        onClick={onSubmitClick} />

                    <Button id="cancel" text="Cancel" icon="close" type="normal"
                        className="pw-button"
                        hint="close dialog"
                        height='1.8rem'
                        onClick={onCancelClick} />
                </div>
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    function onCancelClick() {
        if (props.onCancel)
            props.onCancel();
    }

    function onSubmitClick() {
        if (selectedBatch && props.onSubmit)
            props.onSubmit(selectedBatch);
    }

    function batchFilterChanged(e: any) {
        setBatchFilterString(e.value);
    }

    async function searchResultsSelectionChanged(e: any) {

        console.log("searchResultsSelectionChanged");
        console.log(e);

        if (e.selectedRowsData && e.selectedRowsData.length > 0 &&
            e.selectedRowsData[0]) {
            setSelectedBatch(e.selectedRowsData[0]);
        }
    }

    function onSearchButtonClicked(e: any) {
        if (batchFilterString)
            getBatchesList(batchFilterString);
    }

    async function getBatchesList(search: string) {
        await CrudFunctions.getData(`products/batchesbypartnumberbatchname/${search}`)
            .then(data => {
                setBatches(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Batches");
            });
    }


    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }


}

